import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getBusinessGroupDatatable,
  getBusinessById,
  getBusinessGroupsByUserId,
  getBusinessByIdMultilingual,
  createBusinessMultilingual,
  editBusinessMultilingual,
} from './thunks';
import { businessGroupState } from './types';

export const name = 'businessGroup';

const initialState: businessGroupState = {
  data: null,
  status: 'idle',
  updatingStatus: 'idle',
  details: null,
  detailsHistory: [],
  businessGroupsByUserId: {
    data: [],
    status: 'idle',
  },
  detailsMultilingual: {
    data: null,
    status: 'idle',
  },
  createMultiligual: {
    data: null,
    status: 'idle',
  },
  editMultilingual: {
    status: 'idle',
  },
};

export const getBusinessDatatableAsync = createAsyncThunk(
  name + '/getBusinessGroupDatatable',
  getBusinessGroupDatatable
);

export const getBusinessByIdAsync = createAsyncThunk(
  name + '/getBusinessById',
  getBusinessById
);

export const getBusinessGroupsByUserIdAsync = createAsyncThunk(
  name + '/getBusinessGroupsByUserId',
  getBusinessGroupsByUserId
);

export const getBusinessByIdMultilingualAsync = createAsyncThunk(
  name + '/getBusinessByIdMultilingual',
  getBusinessByIdMultilingual
);

export const editBusinessMultilingualAsync = createAsyncThunk(
  name + '/editBusinessMultilingual',
  editBusinessMultilingual
);

export const createBusinessMultilingualAsync = createAsyncThunk(
  name + '/createBusinessMultilingual',
  createBusinessMultilingual
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
    clearDetails: (state) => {
      state.details = null;
    },
    clearDetailsMultilingual: (state) => {
      state.detailsMultilingual = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessDatatableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBusinessDatatableAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getBusinessDatatableAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(getBusinessByIdAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBusinessByIdAsync.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          details: action.payload,
          detailsHistory: [...state.detailsHistory, action.payload],
        };
      })
      .addCase(getBusinessByIdAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(getBusinessGroupsByUserIdAsync.pending, (state) => {
        state.businessGroupsByUserId.status = 'loading';
      })
      .addCase(getBusinessGroupsByUserIdAsync.fulfilled, (state, action) => {
        state.businessGroupsByUserId = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getBusinessGroupsByUserIdAsync.rejected, (state, action) => {
        state.businessGroupsByUserId.status = 'failed';
      })
      .addCase(getBusinessByIdMultilingualAsync.pending, (state) => {
        state.detailsMultilingual.status = 'loading';
      })
      .addCase(getBusinessByIdMultilingualAsync.fulfilled, (state, action) => {
        state.detailsMultilingual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getBusinessByIdMultilingualAsync.rejected, (state, action) => {
        state.detailsMultilingual.status = 'failed';
      })
      .addCase(createBusinessMultilingualAsync.pending, (state) => {
        state.createMultiligual.status = 'loading';
      })
      .addCase(createBusinessMultilingualAsync.fulfilled, (state, action) => {
        state.createMultiligual = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createBusinessMultilingualAsync.rejected, (state, action) => {
        state.createMultiligual.status = 'failed';
      })
      .addCase(editBusinessMultilingualAsync.pending, (state) => {
        state.editMultilingual.status = 'loading';
      })
      .addCase(editBusinessMultilingualAsync.fulfilled, (state, action) => {
        state.editMultilingual.status = 'idle';
      })
      .addCase(editBusinessMultilingualAsync.rejected, (state, action) => {
        state.editMultilingual.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
